export default __webpack_public_path__ + "static/windows-cc-ab4d53477fc135209d5824a7e7615df8.webm";